import Nav from "../layout/nav/desktopNav";
import MobileNav from "../layout/nav/mobileNav";
import Footer from "../components/footer/Footer.js";
import Header from "../components/page-title/header.js";
import Policy from "../components/Voorwaarden/policy.js";

function PolicyPage() {
  return (
    <div>
      <Nav />
      <MobileNav />

      <Header
        height={30}
        heightState={true}
        title="Privacy beleid"
        text="22/10/2023"
      />
      <Policy />
      <Footer />
    </div>
  );
}

export default PolicyPage;
